import { IPublication } from 'src/types/menu.types';
import { IPublishDestination } from '../../../components/PublishModal/types';
import { getVenuesToPublishTo } from '../getVenuesToPublishTo/getVenuesToPublishTo';
import { IAggregator } from 'src/types/aggregator.types';
import { IntegrationType } from '../../../constants';

export const getExternalSystemsVenuesStatuses = (
  menuPublicationStatus: IPublication,
  externalSystems: IAggregator[],
  isTrial: boolean,
): IPublishDestination[] => {
  return externalSystems
    .filter((external_system) => external_system.integrationType === IntegrationType.DELIVERY_SERVICE)
    .map((external_system: IAggregator): IPublishDestination => {
      const externalSystem = menuPublicationStatus?.aggregators.find(
        (aggregator) => aggregator.aggregatorId === external_system.aggregatorId,
      );
      return {
        channel_id: external_system.aggregatorId,
        name: external_system.name,
        ...(externalSystem && {
          publicationStatus: externalSystem.publicationStatus,
          publicationDate: externalSystem.publicationDate,
        }),
        venues: getVenuesToPublishTo(external_system.venues, externalSystem, isTrial),
      };
    });
};
